module.exports = __webpack_public_path__ + "img/orange-logo.717a45de.svg";